import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { gamePlanService } from '@/services/game-plan.service';

/**
 * Debounced playbook search. Returns the fragment ids in final relevance order
 * as ranked by the server (semantic + lexical blend — the same ranking the
 * eval measures), or undefined while idle/loading. The page maps these ids to
 * the fragments it already holds; it does NOT re-rank.
 */
export function usePlaybookSearch(query: string): { orderedIds: string[] | undefined } {
  const [debounced, setDebounced] = useState('');

  useEffect(() => {
    const id = setTimeout(() => setDebounced(query.trim()), 250);
    return () => clearTimeout(id);
  }, [query]);

  const { data } = useQuery({
    queryKey: ['game-plan', 'search', debounced],
    queryFn: () => gamePlanService.searchPlaybook(debounced),
    enabled: debounced.length > 0,
    staleTime: 5 * 60 * 1000,
  });

  return { orderedIds: data?.map((h) => h.id) };
}
